import { render } from "./brand-tile.vue?vue&type=template&id=09f794bc"
import script from "./brand-tile.vue?vue&type=script&lang=js"
export * from "./brand-tile.vue?vue&type=script&lang=js"

import "./brand-tile.vue?vue&type=style&index=0&id=09f794bc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__